import { render } from "./HeroiconsSolidFolderDownload.vue?vue&type=template&id=11f48fba"
const script = {}

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidFolderDownload.vue"]])

export default __exports__